import { Container } from 'common/components';
import { useSelector } from 'react-redux';
import { Typography } from 'fronton-react';
import { questionsArr } from 'data';
import React from 'react';
import { WindowTypes, selectWindowType } from 'store/pageStore';
import { checkScreenType } from 'utils';
import { Question } from '../question/question';
import { questionsHeaderStyles, questionsStyles } from './styles';

export const QuestionsContainer = () => {
	const currentWindowType = useSelector(selectWindowType);
	const isMobile = checkScreenType(currentWindowType, WindowTypes.mobile);
	return (
		<Container>
			<Typography
				className={questionsHeaderStyles}
				variant={isMobile ? 'h2' : 'h1'}
				as="h2"
				overrideStyles={false}
			>
				Вопросы и ответы
			</Typography>
			<div className={questionsStyles}>
				{questionsArr.map(el => (
					<Question mobile={isMobile} {...el} key={el.question} />
				))}
			</div>
		</Container>
	);
};
